import React from 'react';

export default () => {
  return (
    <div className="step row">
      <div className="col-md-12">
        <p style={{ fontSize: '16px' }}>
          <strong>
            ¡Te felicitamos por tu deseo de conocer qué tan feliz eres en tu
            trabajo, ya que la felicidad laboral está vinculada con índices de
            productividad y compromiso.
          </strong>
        </p>
        <p style={{ fontSize: '16px' }}>
          ¿Y qué es exactamente la felicidad en el trabajo? Es lograr el
          bienestar de los colaboradores de tu empresa a través de un buen clima
          laboral, un cómodo espacio de trabajo, motivación, oportunidad de
          desarrollo profesional y reconocimiento del trabajo. Estás a punto de
          contestar 47 preguntas, las cuales de manera instantánea harán un
          diagnóstico de cuáles dimensiones están impactando de manera positiva
          o negativa tu felicidad laboral.
        </p>
        <p>
          Los resultados por debajo de 85% de satisfacción necesitan de tu
          atención y alerta, para identificar acciones concretas y trabajarlos
          con prontitud. El tiempo promedio para contestar la encuesta es de 5
          minutos.
        </p>
        <p>
          <strong>¡A crear la felicidad que quieres!</strong>
        </p>
      </div>
    </div>
  );
};



// WEBPACK FOOTER //
// ./src/pages/survey/questions/Intro.jsx